import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import PageFrame from "Pages/PageFrame";
import ErrorPage from "Pages/Error";

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/web/**" component={PageFrame} />
        <Route exact path="/error" render={()=><ErrorPage errorNo="404" errorTitle="Not Found" />} />
        <Redirect exact path="/" to="/web/issue" />
        <Redirect path="*" to="/error" />
      </Switch>
    </Router>
  );
}

export default App;